import { useSelectorKiosk } from "./Kiosk/useSelectorKiosk";

const useVoice = () => {
  const selector = useSelectorKiosk((state) => state.voice);
  return selector;
};

export default useVoice;
